import React, { useState, useEffect, useRef, useReducer, useContext } from 'react'
import { useForm } from 'react-hook-form'
import Select from '../../../dpe-usco/components/Select/Select'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import TypeAhead from '../../../dpe-usco/components/TypeAhead/TypeAhead'
import { searchCompaniesByType, getProductionPlan } from '../../../services/apiHelper'
import { GlobalContext } from '../../../services/context'

const ParentProductionPlanWidget = ({ returnData, parentCompanyInfo, planState }) => {
  const { trackEvent } = useContext(GlobalContext)
  const { handleSubmit, register, watch } = useForm()
  const [parentCompanyName, setParentCompanyName] = useState('')
  const [productionPlanYear, setProductionPlanYear] = useState()
  
  const formReducer = (state, action) => {
    switch (action.type) {
      case 'PERMIT_SEARCH':
        return { ...state, permitSearch: true }
      case 'SET_YEAR_OPTIONS':
        return { ...state, grainReceiverUpdate: false, yearOptions: action.payload.yearOptions }
      case 'SET_BY_CLICK':
        setParentCompanyName(action.payload.company_name)
        return { ...state, permitSearch: false, grainReceiverId: action.payload.company_id, grainReceiverUpdate: true }
      case 'SET_BY_PROPS':
        setParentCompanyName(action.payload.parentCompanyName)
        setProductionPlanYear(action.payload.planYear)
        return { ...state, permitSearch: false, setBy: 'PROPS' }
      default:
        return { ...state }
    }
  }
  const [formState, formDispatch] = useReducer(formReducer, {
    permitSearch: true,
    yearOptions: []
  })
  const [companyNameData, setCompanyNameData] = useState()
  const watchParentPlanCheckbox = watch('parentPlanCheckbox', false)

  const onSubmit = () => {
    return null
  }

  const handleSelectYear = option => {
    setProductionPlanYear(option.value)
    returnData({ type: 'UPDATE_PARENT_PRODUCTION_PLAN', payload: option })
  }

  const prevParentPlan = useRef(false)
  useEffect(()=> {
    if(watchParentPlanCheckbox !== prevParentPlan.current){
      if(!watchParentPlanCheckbox) {
        setCompanyNameData('')
        setParentCompanyName(parentCompanyInfo ? parentCompanyName : '')
        formDispatch({ type: 'SET_YEAR_OPTIONS',payload: { grainReceiverUpdate: false, yearOptions:[] } })
        returnData({ type: 'UPDATE_PARENT_PRODUCTION_PLAN', payload: { production_plan_id:'',prod_plan_obj:[] } })
      } else {
        if(parentCompanyInfo){
          returnData({ type: 'UPDATE_PARENT_PRODUCTION_PLAN', payload: { production_plan_id:parentCompanyInfo.parent_id,prod_plan_obj:parentCompanyInfo.monthly_units } })
        }
      }
      prevParentPlan.current = watchParentPlanCheckbox
      trackEvent(`parent_production_plan_${watchParentPlanCheckbox ? 'checked' : 'unchecked'}`)
    }
  }, [watchParentPlanCheckbox, trackEvent, returnData, parentCompanyInfo, parentCompanyName])

  useEffect(()=> {
    const handleNewGrainReceiver = async () => {
      const response = await getProductionPlan(formState.grainReceiverId, 'company_id')
      let newYearOptions = []
      if(response && response.length){
        response.forEach(plan => {
          if(plan.monthly_units.length){
            const year = plan.monthly_units[0].year
            newYearOptions.push({
              production_plan_id: plan.production_plan_id,
              value: year,
              prod_plan_obj: plan.monthly_units
            })
          }
        })
      } else {
        returnData({ type: 'SET_ERROR_STATUS', payload: { errorType: 'productionPlan', errorValue:'The selected grain receiver does not have any production plans' } })
      }
      if(newYearOptions.length){
        formDispatch({ type: 'SET_YEAR_OPTIONS', payload: { grainReceiverUpdate: false, yearOptions: newYearOptions } })
      } else {
        returnData({ type: 'SET_ERROR_STATUS', payload: { errorType: 'parentProductionPlan', errorValue:'The selected grain receiver\'s production plan(s) is missing monthly units' } })
      }

    }
    if (formState.grainReceiverUpdate){
      handleNewGrainReceiver()
    }
  }, [
    formState.grainReceiverUpdate, formDispatch, formState.grainReceiverId, returnData
  ])
  
  const companyNameSelect = selectedCompany => {
    formDispatch({ type: 'SET_BY_CLICK', payload: selectedCompany })
  }

  useEffect(()=> {
    if(parentCompanyInfo){
      if(parentCompanyInfo.planYear !== productionPlanYear && parentCompanyInfo.parentCompanyName !== parentCompanyName){
        formDispatch({ type: 'SET_BY_PROPS', payload: parentCompanyInfo  })
        returnData({ type: 'UPDATE_PARENT_PRODUCTION_PLAN', payload: { production_plan_id:parentCompanyInfo.parent_id,prod_plan_obj:parentCompanyInfo.monthly_units } })
      }
    }
  }, [
    parentCompanyInfo, parentCompanyName, productionPlanYear, returnData
  ])

  useEffect(()=> {
    if(formState.permitSearch) {
      if(parentCompanyName && prevSearch.current !== parentCompanyName &&
        parentCompanyName.length >= 3) {
        searchCompaniesByType(parentCompanyName, 'grain-receiver')
          .then(res => {
            res = res.filter(el => el.company_name !== planState.company_name)
            setCompanyNameData(res)
          })
      }
    } else {
      formDispatch({ type: 'PERMIT_SEARCH' })
    }
  }, [
    formState.permitSearch, parentCompanyName, setCompanyNameData, planState.company_name
  ])

  const prevSearch= useRef()
  useEffect(()=> {
    prevSearch.current = parentCompanyName
  })

  return (
    <Widget title='Parent production plan'>
     
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${watchParentPlanCheckbox? 'bb1-s-lightgray ': '' }mt20 mb10 df aic jcfs`}>
          <div className='mb20 mr20 df aic jcfs'>
            <input className='w15' type='checkbox' id='parentPlanCheckbox' name='parentPlanCheckbox' ref={register()} defaultChecked={parentCompanyInfo?true:false}/>
            <label htmlFor='parentPlanCheckbox'>Include a parent production plan?</label>
          </div>
        </div>
        {(watchParentPlanCheckbox) && 
        <div className='df jcsb'>
          <div className='w45%'>
            <label className='df mb10' htmlFor='parentCompanyName'>Parent company name</label>
            <TypeAhead className='mb20' id='parentCompanyName' name='parentCompanyName'
              value={parentCompanyName}
              onChange={e=>setParentCompanyName(e.target.value)}
              item_id='company_id'
              item_value='company_name'
              data={companyNameData}
              callback={companyNameSelect}
            />
          </div>
          <div className='w45% df fxdrc aifs mb20'>
            <label className='mb10' htmlFor='productionPlanYear'>Production plan year</label>
            <Select
              defaultValue={parentCompanyInfo? parentCompanyInfo.planYear : null}
              placeholder='Select a year'
              handleSelection={handleSelectYear}
              options={formState.yearOptions}
              name='productionPlanYear'
              id='productionPlanYear'
            />
          </div>
        </div>
        }
      </form>
    </Widget>)
}

export default ParentProductionPlanWidget